import $ from 'jquery'
import _ from 'lodash'
import BootslideMenu from './bootslide-menu'
import i18n from '../i18n'
import { precisionOptions, DEFAULT_PRECISION_VALUE } from '../dropdown'
import Backbone from 'backbone'

/**
 * Renders an individual precision menu option (eg "2 digits")
 */
const PrecisionOption = BootslideMenu.WidgetMultipleChoiceOption.extend({
	property: 'precision',

	initialize: function (opt) {
		// Representing value as a String so that 0 doesn't equal ''
		this.value = String(opt.id)

		// No concerns about XSS here; all these strings come from i18n codes
		let postLabel = `<span class="post-label">${opt.postLabel ?? ''}</span>`
		this.label = $(`<span>${opt.label}${postLabel}</span>`)[0]

		BootslideMenu.WidgetMultipleChoiceOption.prototype.initialize.apply(this, arguments)
	},

	selected: function () {
		let current = this.model.get(this.property)
		if (this.value === DEFAULT_PRECISION_VALUE) {
			// Widget may not have the property at all; so look for either the
			// default value from precisionOptions() or the absence of the property
			return _.isNil(current) || current === DEFAULT_PRECISION_VALUE
		}

		return BootslideMenu.WidgetMultipleChoiceOption.prototype
			.selected.apply(this, arguments)
	}
})

/**
 * Renders the top-level precision menu label and current value
 * (eg "Decimal Precision [current precision]")
 */
const PrecisionLabelView = Backbone.View.extend({
	className: 'config-precision',

	initialize: function () {
		this.listenTo(this.model.properties, 'change', this.render.bind(this))
	},

	render: function () {
		let label = i18n.get('scorecards.node.metric.decimalPrecision')
		let current = this.model.properties.get('precision') ?? ''
		this.$el.html(`${label}<span class="current-value">${current}</span>`)
		return this
	}
})

/**
 * Create the precision menu and submenu for a widget bootslide menu
 *
 * @param {WidgetModel} model
 * @param {BootslideMenu} bootslideMenu
 */
function createPrecisionMenu ({ model, bootslideMenu }) {
	let targets = precisionOptions().map(opt => {
		let contentView = new PrecisionOption(_.extend(opt, {
			model: model.properties,
			widgetUpdater: bootslideMenu.options.widgetUpdater
		}))

		return {
			id: 'precision',
			contentView
		}
	})

	return {
		label: i18n.get('scorecards.node.metric.decimalPrecision'),
		contentView: PrecisionLabelView,
		target: targets
	}
}

export default createPrecisionMenu
export { PrecisionOption }

createPrecisionMenu.__filename__ = 'components/bootslide/create-precision-menu.js'
